import { BaseResponseSchema } from '../../schemas.js';
import { applyFingerprintInferenceBatchRequestSchema, createFingerprintInferenceBatchRequestSchema, createFingerprintInferenceBatchResponseSchema, fingerprintInferenceBatchIdParamSchema, fingerprintInferenceBatchProgressResponseSchema, fingerprintInferenceBatchStatusResponseSchema, retryFingerprintInferenceBatchRequestSchema, } from '../../fingerprint-inference.schemas.js';
/** REST contract for `insight-api/src/routes/tenant/fingerprint-inference.routes.ts`. */
export const fingerprintInferenceContract = {
    createBatch: {
        method: 'POST',
        path: '/tenant/fingerprint-inference/batches',
        body: createFingerprintInferenceBatchRequestSchema,
        response: createFingerprintInferenceBatchResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 130000,
        errorMessage: 'Failed to create fingerprint inference batch',
    },
    getBatchStatus: {
        method: 'GET',
        path: '/tenant/fingerprint-inference/batches/:batchId/status',
        pathParams: fingerprintInferenceBatchIdParamSchema,
        response: fingerprintInferenceBatchStatusResponseSchema,
        responseStyle: 'unwrap-data',
        skipAuthRefresh: true,
        errorMessage: 'Failed to get fingerprint inference batch status',
    },
    getBatchProgress: {
        method: 'GET',
        path: '/tenant/fingerprint-inference/batches/:batchId',
        pathParams: fingerprintInferenceBatchIdParamSchema,
        response: fingerprintInferenceBatchProgressResponseSchema,
        responseStyle: 'unwrap-data',
        skipAuthRefresh: true,
        errorMessage: 'Failed to get fingerprint inference batch progress',
    },
    retryBatch: {
        method: 'POST',
        path: '/tenant/fingerprint-inference/batches/:batchId/retry',
        pathParams: fingerprintInferenceBatchIdParamSchema,
        body: retryFingerprintInferenceBatchRequestSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to retry fingerprint inference batch',
    },
    applyBatch: {
        method: 'POST',
        path: '/tenant/fingerprint-inference/batches/:batchId/apply',
        pathParams: fingerprintInferenceBatchIdParamSchema,
        body: applyFingerprintInferenceBatchRequestSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to apply fingerprint inference batch',
    },
};
//# sourceMappingURL=fingerprint-inference.contract.js.map